import { loadIntercom } from '../services/intercom.js'
import { loadOnetrust } from '../services/onetrust'
import { loadRecaptcha } from '../services/recaptcha'
import { loadSentry } from '../services/sentry'

loadOnetrust()
loadRecaptcha()
loadIntercom()
loadSentry()
